import './App.css';
import { Redirect, Route, Switch } from 'react-router-dom';
//import Sandbox from './components/Sandbox';
import Train from './components/Train';
import Quiz from './components/Quiz';
import QuizResult from './components/QuizResult';
import StartPage from './components/StartPage';
import styled, { css } from 'styled-components'
import pattern from './img/simple_pattern.svg'
import { cards } from './data/cardInfo';
import Card from './components/Card';
import QuizContextProvider from './context/QuizContext';
import About from './components/About';
import QuizSelect from './components/QuizSelect';


const Wrapper = styled.div`
  display:grid;
  place-items: center;
  height: 100%;
`

const Container = styled.div`
  max-width: 70em;
  margin: 0 0em;
  background: white;
  //padding: 2em;
`

const FloatingBackground = styled.div`
  position: fixed;
  top:0;
  left:0;
  background-image: url(${pattern});
  opacity: 0.3;
  
  background-attachment: fixed;
  background-size: cover;
  background-position: 0% 0%;
  z-index: -1;
  width: 100vw;
  height: 100vh;
`

function App() {
  
  return (
    
    <div className="App">
      {/* <FloatingBackground /> */}
      <div className="floating-background"></div>
      <Wrapper>
      <Container>
        <Switch>
          <Route exact path='/'>
            <StartPage />
          </Route>
          <Route exact path='/train'>
            <Train />
          </Route>
          {/* <Route path='/sandbox'>
            <Sandbox />
          </Route> */}
          <Route path='/quiz/:difficulty'>
            <QuizContextProvider>
              <Quiz />
            </QuizContextProvider>
          </Route>
          <Route path='/difficulty'>
            <QuizSelect />
          </Route>
          <Route path='/result'>
            <QuizResult />
          </Route>
          <Route path='/card'>
            <Card cardData={cards[13]} />
          </Route>
          <Route path='/about'>
          <About />
          </Route>
          <Route path='*'>
            <Redirect to='/' />
          </Route>
        </Switch>
        </Container>
      </Wrapper>
    </div>
  );
}

export default App;
